export const ROUTES = {
  intro: "/intro",
  home: "/home",
  game: "/game",
  overworld: "/overworld",
  journey: "/journey",
  codex: "/codex",
  settings: "/settings",
  language: "/language",
  credits: "/credits",
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
